import { FcGraduationCap, FcOk, FcVoicePresentation, FcRuler, FcTodoList, FcManager, FcQuestions, FcCancel, FcLock, FcInspection, FcReading } from 'react-icons/fc'
import React, { useEffect, useState } from 'react'
import { useFetch } from '../../../services/ApiService';
import { Button, Card, Result, Skeleton, message } from 'antd';
import { CheckOutlined, DownloadOutlined, FileTextTwoTone, ScheduleOutlined, ScheduleTwoTone } from '@ant-design/icons';
import { trucatePercentage } from '../../Utility/Functions';

function ExamResult({ applicationData, refreshData }) {

    const [appReportData, setAppReportData] = useState({});
    const [loading, setLoading] = useState();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const { fetchApi } = useFetch();
    const [certificateLoading, setCertificateLoading] = useState(false);
    const getApplicationReport = async () => {
        setLoading(true);

        if (applicationData.status_id !== 5) {
            await fetchApi(`/api/examresultsnapshot?application_id=${applicationData.id}`).then(res => {
                setAppReportData(res[0].snapshot_result.exam_score_by_application);
            })
        }
        else {
            await fetchApi(`/api/reports/exam_score_by_application?application_id=${applicationData.id}`).then(res => {
                setAppReportData(res[0]);
                setLoading(false);
            })
        }
        setLoading(false);
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement("a");
        // create a blobURI pointing to our Blob
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        // some browser needs the anchor to be in the doc
        document.body.append(link);
        link.click();
        link.remove();
        // in case the Blob uses a lot of memory
        setTimeout(() => URL.revokeObjectURL(link.href), 1000);
    };

    const handleDownloadCertificate = async () => {
        setCertificateLoading(true);
        await fetchApi(`/api/application/pdf/${applicationData.id}`, 'GET', {}, {}, { responseType: 'blob' }).then(res => {
            downloadFile(res, `${applicationData.candidate_name}_${applicationData.id}_Certificate.pdf`);
            setCertificateLoading(false);
        }).catch(err => {
            message.error('Error while downloading certificate.')
        })
        setCertificateLoading(false);
    }

    useEffect(() => {
        getApplicationReport();

    }, [applicationData]);

    return (
        <Skeleton loading={loading} active>
            {/* <div className="row">

        <div className="col-lg-3 col-sm-6 mb-4">
          <div className="border rounded-3 p-3 d-flex align-items-center">
            <FcGraduationCap size={48} />
            <div className='ms-3 exam-details-tiles-texts'>
              <div className='text-muted fw-semibold'>Percentage</div>
              <div className="h5 mb-0"><span>{appReportData.percentage ? trucatePercentage(appReportData.percentage) : 0}%</span> </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6 mb-4">
          <div className="border rounded-3 p-3 d-flex align-items-center">
            {
              appReportData.shortlisted ?
                <FcOk size={48} /> : <FcCancel size={48} />
            }

            <div className='ms-3 exam-details-tiles-texts'>
              <div className='text-muted fw-semibold'>Test Result</div>
              <div className="h5 mb-0">{appReportData.shortlisted ? 'Shortlisted' : 'Rejected'}</div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6 mb-4">
          <div className="border rounded-3 p-3 d-flex align-items-center pe-0">
            <FcQuestions size={48} />
            <div className='ms-3 exam-details-tiles-texts'>
              <div className='text-muted fw-semibold'>Exam Code</div>
              <div className="h5 mb-0">{appReportData.exam_code_name}</div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6 mb-4">
          <div className="border rounded-3 p-3 d-flex align-items-center pe-0">
            <FcManager size={48} />
            <div className='ms-3 exam-details-tiles-texts'>
              <div className='text-muted fw-semibold'>Assessor</div>
              <div className="h5 mb-0">{appReportData.examinator_name}</div>
            </div>
          </div>
        </div>
      </div>
      <div className='view-status mt-2 justify-content-center'>
        <p className='fw-semibold fs-4 text-center mx-0 my-0'>{
          !applicationData.is_exam_snapshot ? 'Exam Result is not confirmed.' : 'Exam Result is confirmed.'
        }</p>
      </div> */}


            <>
                <div className="row">

                    <div className="col-lg-4 col-sm-6 mb-4">
                        <div className="border rounded-3 p-3 d-flex align-items-center">
                            <FcGraduationCap size={48} />
                            <div className='ms-3 exam-details-tiles-texts'>
                                <div className='text-muted fw-semibold'>Percentage</div>
                                <div className="h5 mb-0"><span>{appReportData.percentage ? trucatePercentage(appReportData.percentage) : 0}%</span> </div>
                            </div>
                        </div>
                    </div>


                    <div className="col-lg-4 col-sm-6 mb-4">
                        <div className="border rounded-3 p-3 d-flex align-items-center">
                            <FcTodoList size={48} />
                            <div className='ms-3 exam-details-tiles-texts'>
                                <div className='text-muted fw-semibold'>Theory Exam Score</div>
                                <div className="h5 mb-0"><span>{appReportData.theory_obtained_score !== null ? appReportData.theory_obtained_score : 'NA'} / {appReportData.theory_max_score !== null ? appReportData.theory_max_score : 'NA'}</span> </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 mb-4">
                        <div className="border rounded-3 p-3 d-flex align-items-center">
                            <FcRuler size={48} />
                            <div className='ms-3 exam-details-tiles-texts'>
                                <div className='text-muted fw-semibold'>Practical Exam Score</div>
                                <div className="h5 mb-0"><span>{appReportData.practical_obtained_score !== null ? appReportData.practical_obtained_score : 'NA'} / {appReportData.practical_max_score !== null ? appReportData.practical_max_score : 'NA'}</span> </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 mb-4">
                        <div className="border rounded-3 p-3 d-flex align-items-center">

                            {
                                appReportData.shortlisted ?
                                    <FcOk size={48} /> : appReportData.training ? <FcReading size={48} /> : <FcCancel size={48} />
                            }

                            <div className='ms-3 exam-details-tiles-texts'>
                                <div className='text-muted fw-semibold'>Test Result</div>
                                <div className="h5 mb-0">{appReportData.shortlisted ? 'Recommended' : appReportData.training ? 'Training Required' : 'Rejected'}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 mb-4">
                        <div className="border rounded-3 p-3 d-flex align-items-center pe-0">
                            <FcQuestions size={48} />
                            <div className='ms-3 exam-details-tiles-texts'>
                                <div className='text-muted fw-semibold'>Exam Code</div>
                                <div className="h5 mb-0">{appReportData.exam_code_name}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 mb-4">
                        <div className="border rounded-3 p-3 d-flex align-items-center pe-0">
                            <FcManager size={48} />
                            <div className='ms-3 exam-details-tiles-texts'>
                                <div className='text-muted fw-semibold'>Assessor</div>
                                <div className="h5 mb-0">{appReportData.examinator_name}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row mb-4'>
                    <div className={applicationData.status_id !== 5 ? "col-md-6" : "col-md-12"}>
                        <Card>
                            <Result
                                icon={<FcInspection size={64} />}
                                title="Exam Result Confirmed"
                                subTitle="This applicant's exam result is confirmed."
                            />
                        </Card>
                    </div>

                    {
                        applicationData.status_id !== 5 &&
                        <div className="col-md-6">
                            <Card>
                                <Result
                                    icon={<ScheduleTwoTone />}
                                    title="Download Certificate"
                                    subTitle="Download the certificate for the applicant."
                                    extra={
                                        <Button
                                            loading={certificateLoading}
                                            className='fw-semibold ms-4'
                                            type='primary'
                                            size='large'
                                            icon={<DownloadOutlined />}
                                            onClick={handleDownloadCertificate}
                                        >
                                            Download
                                        </Button>
                                    }
                                />
                            </Card>
                        </div>
                    }
                </div>
            </>


        </Skeleton>
    )
}

export default ExamResult